require("./SummaryDateSelector.less");

const React = require("react");
const moment = require("moment");

const QuestionType = require("~/types/Question.js").PropType;
const SummaryComment = require("../SummaryComment/SummaryComment.jsx");

const SummaryDateSelector = React.createClass({
    propTypes: {
        Question: QuestionType.isRequired,
    },

    render() {
        const showCommentField = this.props.Question.AdditionalComment != "";

        const score = this.props.Question.MaxScore === 0
            ? ""
            : `${this.props.Question.Score}/${this.props.Question.MaxScore}`;

        const parsed = moment(this.props.Question.AnswerSelections[0].SelectionText);

        const display = parsed.isValid()
            ? parsed.format("M/D/YYYY")
            : "";

        return (<div className="cs-SummaryDateSelector">
            <div className="cs-SummaryDateSelector__Border">
                        <div className="cs-SummaryDateSelector__Question"
                             dangerouslySetInnerHTML={{ __html: this.props.Question.DisplayHTML }}></div>
                        <div className="cs-SummaryDateSelector__Answer">
                            {display}
                        </div>
                        <div className="cs-SummaryDateSelector__Points">
                            {score}
                        </div>
            </div>
            <div className="cs-SummaryDateSelector__Border">
                {showCommentField && (
                <SummaryComment Comment={this.props.Question.AdditionalComment} />)}
            </div>
        </div>);
    }
});

module.exports = SummaryDateSelector;


// WEBPACK FOOTER //
// ./src/components/SurveySummary/SummaryDateSelector/SummaryDateSelector.jsx